<template>
  <div>
    <div class="profession-bar" @click="formVisible = true">
      {{ mold.name }}
    </div>
    <div class="profession-form-wrapper">
      <el-dialog
        :title="mold.title"
        :visible.sync="formVisible"
        :before-close="handleFormClose"
        :close-on-click-modal="false"
        custom-class="handlian-report-container"
        width="700px"
      >
        <div class="profession-tip">
          <p>{{ initTagline }}</p>
          <p>如需了解详情，请咨询 {{ companyInfo.mobile }}</p>
        </div>
        <el-form
          :model="professionForm"
          :rules="rules"
          ref="professionForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="name" class="form-item">
            <el-input
              v-model="professionForm.name"
              placeholder="输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="mobile" class="form-item">
            <el-input
              v-model="professionForm.mobile"
              placeholder="输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address" class="form-item">
            <el-input
              type="text"
              v-model="professionForm.address"
              placeholder="输入详细地址"
            ></el-input>
          </el-form-item>
          <el-form-item class="form-item">
            <el-button
              class="apply-profession-btn"
              type="primary"
              @click="submitForm('professionForm')"
              >提交</el-button
            >
            <el-button
              class="apply-profession-btn"
              @click="resetForm('professionForm')"
              >重置</el-button
            >
            <span
              v-show="getListBtn"
              class="view-history-btn"
              @click="getBusinessList"
              >查看记录</span
            >
          </el-form-item>
        </el-form>
        <div class="profession-list-wrapper">
          <el-dialog
            title="订单记录"
            :visible.sync="listVisible"
            :before-close="handleListClose"
            :close-on-click-modal="false"
            append-to-body
            destroy-on-close
            custom-class="handlian-report-container"
            width="700px"
          >
            <div class="profession-list-container" v-loading="fetchListOn">
              <div
                class="item-container"
                v-for="(item, index) in professionList"
                :key="index"
              >
                <div class="item-title flex">
                  <p class="user-name">{{ item.name }}</p>
                  <p class="add-time">{{ initItemAddTime(item.created_at) }}</p>
                </div>
                <div class="item-content flex">
                  <p class="item-type">{{ initItemType(item.type) }}</p>
                  <p class="item-status">
                    <span class="status-text">{{
                      initItemStatus(item.state)
                    }}</span>
                    <span class="detail-btn" @click="openOrderDetail(item.id)"
                      >详情</span
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="order-detail-wrap">
              <el-dialog
                :title="initOrderTitle(professionItem.type)"
                :visible.sync="detailVisible"
                :close-on-click-modal="false"
                append-to-body
                custom-class="handlian-report-container"
                width="700px"
              >
                <div class="order-detail-container">
                  <p class="detail-item">
                    <span class="detail-item-title">姓名：</span>
                    <span>{{ professionItem.name }}</span>
                  </p>
                  <p class="detail-item">
                    <span class="detail-item-title">电话：</span>
                    <span>{{ professionItem.mobile }}</span>
                  </p>
                  <p class="detail-item">
                    <span class="detail-item-title">日期：</span>
                    <span>{{
                      initItemAddTime(professionItem.created_at)
                    }}</span>
                  </p>
                  <p class="detail-item">
                    <span class="detail-item-title">地址：</span>
                    <span>{{ professionItem.address }}</span>
                  </p>
                  <p class="steps-text">
                    <span class="detail-item-title">服务进度：</span>
                    <span class="serve-tip">订单在排班之前，可以取消订单</span>
                  </p>
                  <div class="steps-container">
                    <el-steps
                      :active="professionItem.state"
                      finish-status="success"
                    >
                      <el-step title="已提交"></el-step>
                      <el-step title="已排班"></el-step>
                      <el-step title="已结单"></el-step>
                    </el-steps>
                  </div>
                  <div class="detail-btn-bar">
                    <el-button
                      :disabled="initCancelBtn(professionItem.state)"
                      class="cancel-order-btn"
                      @click="cancelOrder(professionItem.id)"
                      >取消订单</el-button
                    >
                  </div>
                </div>
              </el-dialog>
            </div>
          </el-dialog>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../../utils/apiMap";
import { getDate } from "../../../utils/date";
export default {
  name: "profession-form",
  props: {
    mold: Object,
  },
  data() {
    return {
      formVisible: false,
      listVisible: false,
      detailVisible: false,
      fetchListOn: true,
      getListBtn: true,
      professionForm: {
        name: "",
        mobile: "",
        address: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
          {
            min: 1,
            max: 150,
            message: "长度在 1 到 150 个字符",
            trigger: "blur",
          },
        ],
      },
      professionList: [],
      professionItem: {},
    };
  },
  computed: {
    ...mapGetters(["companyInfo"]),
    initTagline() {
      switch (this.mold.type) {
        case 1:
          return "专业为您撰写传记，为子孙留下最辉煌事迹，让家族能量代代传承 。";
        case 2:
          return "专业为您拍照，为子孙留下最美好的瞬间，让家族风光代代传承 。";
        case 4:
          return "专业为您拍摄传记电影，为子孙留下最美好的回忆，让家族精神代代传承 。";
      }
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var filedArray = ["name", "mobile", "address"];
          var submitArry = [];
          let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
          submitArry.push(`token=${loginUser.token}`);
          submitArry.push(`type=${this.mold.type}`);
          for (let index = 0; index < filedArray.length; index++) {
            const element = filedArray[index];
            var filedValue = this.professionForm[element];
            if (filedValue) {
              submitArry.push(`${element}=${filedValue}`);
            }
          }
          this.addBusiness(submitArry);
        } else {
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleFormClose() {
      this.formVisible = false;
      this.resetForm("professionForm");
    },
    handleListClose() {
      this.listVisible = false;
      this.fetchListOn = true;
    },
    addBusiness(params) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["addBusiness"]["method"],
          url: apiMap["addBusiness"]["url"],
          data: params.join("&"),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.handleFormClose();
            _this.$message({
              message: "工单提交成功",
              type: "success",
              duration: 1500,
              offset: 230,
            });
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getBusinessList() {
      let _this = this;
      _this.getListBtn = false;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["businessList"]["method"],
          url: apiMap["businessList"]["url"],
          params: {
            token: loginUser.token,
          },
        })
        .then(function(response) {
          _this.getListBtn = true;
          if (response.data.result.statusCode == 1) {
            _this.listVisible = true;
            _this.professionList = response.data.result.data;
            _this.fetchListOn = false;
          } else {
            _this.$message({
              message: "暂无记录",
              duration: 1500,
              offset: 230,
            });
            _this.listVisible = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initItemAddTime(timeStamp) {
      return getDate(new Date(timeStamp * 1000), ".");
    },
    initItemType(orderType) {
      switch (orderType) {
        case 1:
          return "撰写传记";
        case 2:
          return "专业照相";
        case 4:
          return "拍摄电影";
      }
    },
    initItemStatus(orderState) {
      switch (orderState) {
        case 0:
          return "已提交";
        case 1:
          return "已排班";
        case 2:
          return "已结账";
      }
    },
    initOrderTitle(orderType) {
      switch (orderType) {
        case 1:
          return "撰写传记 订单详情";
        case 2:
          return "专业照相 订单详情";
        case 4:
          return "拍摄电影 订单详情";
      }
    },
    initCancelBtn(orderState) {
      if (orderState == 0) {
        return false;
      } else {
        return true;
      }
    },
    openOrderDetail(orderId) {
      let order = this.professionList.filter((item) => item.id == orderId);
      if (order.length != 0) {
        this.professionItem = order[0];
        this.detailVisible = true;
      } else {
      }
    },
    cancelOrder(orderId) {
      let _this = this;
      _this
        .$confirm("确定取消该订单吗？", {
          confirmButtonText: "确定",
          cancelButtonText: "不取消",
          type: "info",
          closeOnClickModal: false,
        })
        .then(() => {
          let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
          _this
            .$axios({
              baseURL: apiMap["commonUrl"],
              method: apiMap["addBusiness"]["method"],
              url: apiMap["addBusiness"]["url"],
              data: `token=${loginUser.token}&id=${orderId}`,
            })
            .then(function(response) {
              if (response.data.result.statusCode == 1) {
                _this.$message({
                  message: "订单删除成功",
                  type: "success",
                  duration: 1500,
                  offset: 230,
                });
                _this.detailVisible = false;
                _this.fetchListOn = true;
                _this.professionList = [];
                _this.getBusinessList();
              } else {
                _this.$message({
                  message: "删除失败，稍后再试",
                  type: "warning",
                  duration: 1500,
                  offset: 230,
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.profession-bar {
  height: 40px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #ff9800;
}

.profession-tip {
  padding-left: 58px;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 10px;
}

.form-item {
  width: 570px;
}

.apply-profession-btn {
  padding: 7px 10px;
}

.view-history-btn {
  margin-left: 304px;
  cursor: pointer;
  color: #1a70db;
}

.profession-list-container {
  height: 455px;
}

.item-container {
  padding: 10px 15px;
  margin-bottom: 4px;
  background-color: #f5f5f5;
}

.item-title {
  justify-content: space-between;
  line-height: 25px;
}

.item-content {
  justify-content: space-between;
}

.user-name {
  font-size: 16px;
}

.add-time {
  color: #888;
}

.item-type {
  color: #ff9800;
}

.detail-btn {
  margin-left: 10px;
  color: #1a70db;
  cursor: pointer;
}

.order-detail-container {
  width: 90%;
  margin: 0 auto;
}

.detail-item {
  font-size: 16px;
  line-height: 30px;
}

.steps-text {
  margin: 10px 0;
}

.detail-item-title {
  margin-right: 5px;
}

.steps-container {
  margin: 5px 0;
}

.detail-btn-bar {
  margin: 20px 0;
  text-align: center;
}

.cancel-order-btn {
  padding: 7px 10px;
}

.serve-tip {
  color: #888888;
}
</style>
